/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';

interface IProductsColumns {
  showFilters: boolean;
  sortData: (key: string) => void;
  sortConfig: { key: string; direction: string };
}
type ColumnKeys =
  | 'productName'
  | 'hsCode'
  | 'listName'
  | 'agency'
  | 'sourceCountry'
  | 'dateUpdated';

const ProductsColumns: React.FC<IProductsColumns> = ({ showFilters, sortData, sortConfig }) => {
  const [ svgIcons, setSvgIcons ] = useState<Record<ColumnKeys, JSX.Element>>({
    productName: <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <path
        d='M7.99967 12.6666V3.33331M7.99967 3.33331L3.33301 7.99998M7.99967 3.33331L12.6663 7.99998'
        stroke='var(--card-text)'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>,
    hsCode: <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <path
        d='M7.99967 12.6666V3.33331M7.99967 3.33331L3.33301 7.99998M7.99967 3.33331L12.6663 7.99998'
        stroke='var(--card-text)'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>,
    listName: <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <path
        d='M7.99967 12.6666V3.33331M7.99967 3.33331L3.33301 7.99998M7.99967 3.33331L12.6663 7.99998'
        stroke='var(--card-text)'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>,
    agency: <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <path
        d='M7.99967 12.6666V3.33331M7.99967 3.33331L3.33301 7.99998M7.99967 3.33331L12.6663 7.99998'
        stroke='var(--card-text)'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>,
    sourceCountry: <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <path
        d='M7.99967 12.6666V3.33331M7.99967 3.33331L3.33301 7.99998M7.99967 3.33331L12.6663 7.99998'
        stroke='var(--card-text)'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>,
    dateUpdated: <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <path
        d='M7.99967 12.6666V3.33331M7.99967 3.33331L3.33301 7.99998M7.99967 3.33331L12.6663 7.99998'
        stroke='var(--card-text)'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>,
  });

  useEffect(() => {
    const newSvgIcons = { ...svgIcons };

    // Update the SVG icons based on the sorting state
    (Object.keys(newSvgIcons) as ColumnKeys[]).forEach((column) => {
      // Cast keys to ColumnKeys[]
      if (column === sortConfig.key) {
        newSvgIcons[column] = sortConfig.direction === 'asc' ? (
          <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
            <path
              d='M7.99967 12.6666V3.33331M7.99967 3.33331L3.33301 7.99998M7.99967 3.33331L12.6663 7.99998'
              stroke='var(--card-text)'
              strokeWidth='1.33333'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        ) : (
          <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
            <path
              d='M7.99967 3.33331V12.6666M7.99967 12.6666L3.33301 7.99998M7.99967 12.6666L12.6663 7.99998'
              stroke='var(--card-text)'
              strokeWidth='1.33333'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        );
      } else {
        // Reset the icon to the default state
        newSvgIcons[column] = (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
          >
            <path
              d='M7.99967 12.6666V3.33331M7.99967 3.33331L3.33301 7.99998M7.99967 3.33331L12.6663 7.99998'
              stroke='var(--card-text)'
              strokeWidth='1.33333'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        );
      }
    });

    setSvgIcons(newSvgIcons);
  }, [sortConfig]);

  return (
    <div className='screening-results-columns'>
      <div className='screening-table-placeholder-column'></div>
      <div
        className='screening-table-title-column'
        onClick={() => sortData('productName')}
      >
        <div className='screening-table-title-column-inner'>
          <div className='screening-table-column-text'>
            Product Name {svgIcons.productName}
          </div>
        </div>
      </div>
      <div
        className='screening-table-title-column'
        onClick={() => sortData('hsCode')}
      >
        <div className='screening-table-title-column-inner'>
          <div className='screening-table-column-text'>
            HS Code {svgIcons.hsCode}
          </div>
        </div>
      </div>
      <div
        className='screening-table-title-column'
        onClick={() => sortData('listName')}
      >
        <div className='screening-table-title-column-inner'>
          <div className='screening-table-column-text'>
            List Name {svgIcons.listName}
          </div>
        </div>
      </div>

      {!showFilters && (
        <div
          className='screening-table-title-column'
          onClick={() => sortData('agency')}
        >
          <div className='screening-table-title-column-inner'>
            <div className='screening-table-column-text'>
              Agency {svgIcons.agency}
            </div>
          </div>
        </div>
      )}
      {!showFilters && (
        <div
          className='screening-table-title-column'
          onClick={() => sortData('sourceCountry')}
        >
          <div className='screening-table-title-column-inner'>
            <div className='screening-table-column-text'>
              Source Country {svgIcons.sourceCountry}
            </div>
          </div>
        </div>
      )}
      {!showFilters && (
        <div
          className='screening-table-title-column'
          onClick={() => sortData('dateUpdated')}
        >
          <div className='screening-table-title-column-inner'>
            <div className='screening-table-column-text'>
              Date Updated {svgIcons.dateUpdated}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductsColumns;
